import { Card, CardContent, CardHeader } from '@material-ui/core';
import React from 'react';
import FeatureFlagsContext from 'storage/FeatureFlagsContext';
import withMainLayout from 'with/withMainLayout';
import FeatureFlagToggle from './components/FeatureFlagToggle';

function SettingsPage() {
  const { error, flags, isFetching } = FeatureFlagsContext.useContext();

  const showFeatureFlags = String(window?.env?.WOAD_SHOW_FEATURE_FLAGS) === 'true';

  return (
    <Card elevation={3}>
      <CardHeader title="Settings" />

      {showFeatureFlags && (
        <>
          <CardContent>
            {isFetching && <div>Loading feature flags...</div>}
            {error && <div style={{ color: 'red' }}>Failed to load flags: {error.message}</div>}
            {!isFetching && !error && <div>Feature Flags</div>}
          </CardContent>

          <CardContent>
            {Object.keys(flags).map(flag => (
              <FeatureFlagToggle key={flag} active={flags[flag]?.value ?? false} flag={flag} />
            ))}
          </CardContent>
        </>
      )}
    </Card>
  );
}

export default withMainLayout(SettingsPage);
